import React, { useState, useEffect, useContext } from "react";
import Joyride from "react-joyride";
import { getGlobalState } from "../utils/globalState";
import { setNewTopNav } from "../utils/api";

const steps = [
    {
        target: ".add-button",
        content: "Add This Dashboard to your My Dashboards by clicking here."
    },
    {
        target: ".request-button",
        content: "Send a message to the dashboard owner(s) to request access."
    },
    {
        target: ".report-button",
        content: "Report a fault / error in this dashboard."
    },
    {
        target: ".share-button",
        content: "A link to share this dashboard with colleagues.."
    },
];

const NewDashboardTour = () => {
    const [run, setRun] = useState(false);
    const { isNewTopNav } = getGlobalState();

    useEffect(() => {
        if (isNewTopNav === 1) {
            console.log(getGlobalState());
            setRun(true);
        }
    }, [isNewTopNav]);

    const handleJoyrideCallback = async (data) => {
        const { status } = data;
        if (["finished", "skipped"].includes(status)) {
            setRun(false);
            await setNewTopNav();
        }
    };

    return (
        <Joyride
            steps={steps}
            run={run}
            continuous
            showSkipButton
            showProgress
            callback={handleJoyrideCallback}
            styles={{
                options: {
                    primaryColor: "#1976d2", // Change button and beacon color
                    zIndex: 10000,
                },
                beacon: {
                    inner: "#1976d2", // Beacon color
                    outer: "#90caf9",
                },
            }}
        />
    );
};

export default NewDashboardTour;